export default "__VITE_ASSET__OpU0YLzc__"